import { MenuCategoryRegistrationPayload } from 'api/menuCategoryApi';

/**
 * メニューカテゴリー新規作成フォーム
 */
export type MenuCategoryRegistrationFormFields = {
  /** メニューカテゴリーID */
  id: string;
  /** メニューカテゴリー名 */
  name: string;
  /** 並び順 */
  displayOrder: number;
};

export const createMenuCategoryRegistrationFormFields = ({
  id = '',
  name = '',
  displayOrder = 0,
}: Partial<MenuCategoryRegistrationFormFields>): MenuCategoryRegistrationFormFields => ({
  id,
  name,
  displayOrder,
});

export const mapFormFieldsToMenuCategoryRegistrationPayload = ({
  id,
  name,
  displayOrder,
}: MenuCategoryRegistrationFormFields): MenuCategoryRegistrationPayload => ({
  id: /^\d+$/.test(id) ? parseInt(id, 10) : null,
  name,
  displayOrder,
});
